import { MenuButtonItem } from 'components/MenuButton';
import ColorPickerItem from './ColorPickerItem';
import GraphPickerItem from './GraphPickerItem';
import Icon from 'components/base/Icon';

export const getEditMenuItems = ({ editConfig, ...rest }) => {
  const { canChangeColor, canChangeType, canDelete } = editConfig;
  const { graphColor, onColorChange, graphType, onGraphTypeChange, onRemove } =
    rest;
  const menuItems = [];
  if (canChangeColor) {
    menuItems.push(
      <ColorPickerItem graphColor={graphColor} onColorChange={onColorChange} />
    );
  }
  if (canChangeType) {
    menuItems.push(
      <GraphPickerItem
        graphType={graphType}
        onGraphTypeChange={onGraphTypeChange}
      />
    );
  }
  if (canDelete) {
    menuItems.push(
      <MenuButtonItem
        key='delete'
        text='delete'
        icon={<Icon size='small' name='Trash' alpha={0.7} color='torchRed' />}
        onClick={onRemove}
      />
    );
  }
  return menuItems;
};
